import { environment } from "../../config";
import {
  CognitoUser,
  PutUserPassword,
} from "../../interfaces/SuperAdmin/Others/CognitoUser";
import { DynamoUser } from "../../interfaces/SuperAdmin/Others/DynamoUser";
import {
  AllUserResponse,
  iDataUser,
  PostUserFields,
  PostUserResponse,
  PutUserFields,
} from "../../interfaces/SuperAdmin/Pages/iDataUser";
import { iDataUserOrganization } from "../../interfaces/SuperAdmin/Pages/iDataUserOrganization";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL, ENVIRONMENT } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

export const getAllUsers = (version: string, page: number, search?: string) =>
  fetchData<AllUserResponse>({
    method: "GET",
    url: `${baseApiBroker}/usuario`,
    params: {
      version,
      page,
      ...(search && { search }),
    },
  });

export const getUsersByOrgId = (
  id_organizacion?: string,
  id_usuario?: string
) =>
  fetchData<iDataUserOrganization[]>({
    method: "GET",
    url: `${baseApiBroker}/usuario-organizacion`,
    params: {
      ...(id_organizacion && { id_organizacion }),
      ...(id_usuario && { id_usuario }),
    },
  });

export const getUserById = (id: string) =>
  fetchData<iDataUser>({
    method: "GET",
    url: `${baseApiBroker}/usuario/${id}`,
  });

export const postUser = (data: PostUserFields) =>
  fetchData<PostUserResponse>({
    method: "POST",
    url: `${baseApiBroker}/usuario`,
    data,
  });

export const deleteUserById = (id: string) =>
  fetchData<{}>({
    method: "DELETE",
    url: `${baseApiBroker}/usuario/${id}`,
  });

export const putUserById = (id: string, data: PutUserFields) =>
  fetchData<iDataUser>({
    method: "PUT",
    url: `${baseApiBroker}/usuario/${id}`,
    data,
  });

export const getCognitoUsers = (version: string, email: string) =>
  fetchData<CognitoUser[]>({
    method: "GET",
    url: `${baseApiBroker}/usuario/cognito`,
    params: {
      version,
      env: ENVIRONMENT,
      email,
    },
  });

export const getDynamoUsers = (version: string, email: string) =>
  fetchData<DynamoUser[]>({
    method: "GET",
    url: `${baseApiBroker}/usuario/dynamo`,
    params: {
      version,
      env: ENVIRONMENT,
      email,
    },
  });

export const putUserPassword = (username: string, data: PutUserPassword) =>
  fetchData<{}>({
    method: "PUT",
    url: `${baseApiBroker}/usuario/password/${username}`,
    data,
  });
